/** Does nothing, and returns `false`. */
export const nope = (): false => false;

/**
 * Does nothing, and returns `undefined`
 * (or void, if you speak typescript).
 */
export const noop = (): void => undefined;
